var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, Box } from '@chakra-ui/react';
import { useToast } from 'src/core/hooks';
import { ImageBox } from '.';
import { asset } from '@obtainly/utils';
export var ImageUploader = function (_a) {
    var uploadPath = _a.uploadPath, onUpload = _a.onUpload, imageProps = _a.imageProps;
    var toast = useToast().toast;
    var fileInput = React.useRef();
    var _b = React.useState(), uploadData = _b[0], setUploadData = _b[1];
    var _c = React.useState(), imagePreview = _c[0], setImagePreview = _c[1];
    /**
     * If current image in image preview has been uploaded
     * or is in the process
     */
    var _d = React.useState(false), isUploaded = _d[0], setIsUploaded = _d[1];
    var _e = React.useState(false), isUploading = _e[0], setIsUploading = _e[1];
    var handleFileInputChange = function (event) {
        var _a;
        event.preventDefault();
        var reader = new FileReader();
        var file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        reader.onloadend = function () { return __awaiter(void 0, void 0, void 0, function () {
            var type, allowedTypes;
            var _a;
            return __generator(this, function (_b) {
                type = ((_a = file.type.split('/').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
                allowedTypes = ['jpeg', 'jpg', 'png'];
                if (!allowedTypes.includes(type)) {
                    toast({
                        description: 'Please select a valid image file.',
                        status: 'error',
                    });
                }
                else if (file.size > 4024000) {
                    toast({
                        description: 'Max Upload size is 4MB only.',
                        status: 'error',
                    });
                }
                else {
                    setIsUploaded(false);
                    setImagePreview(reader.result);
                    setUploadData({ file: file });
                    // do the actual upload
                }
                return [2 /*return*/];
            });
        }); };
        reader.readAsDataURL(file);
    };
    return (_jsxs(Box, { children: [_jsx("input", { type: "file", className: "hidden-input", accept: "image/jpg, image/jpeg, image/png", onChange: handleFileInputChange, ref: fileInput }, void 0), uploadPath || imagePreview ? (_jsx(Box, __assign({ mb: 2 }, { children: _jsx(ImageBox, __assign({ src: imagePreview ? imagePreview : asset(uploadPath), width: "120px" }, imageProps), void 0) }), void 0)) : null, _jsx(Button, __assign({ size: "sm", variant: "outline", onClick: function () { return fileInput.current.click(); }, isDisabled: isUploading }, { children: uploadPath ? 'Change Image' : 'Upload Image' }), void 0), _jsx(Button, __assign({ size: "sm", colorScheme: "success", ml: 2, onClick: function () {
                    setIsUploading(true);
                    onUpload(uploadData).finally(function () {
                        setIsUploaded(true);
                        setIsUploading(false);
                    });
                }, isDisabled: !uploadData || !uploadData.file || isUploading || isUploaded, isLoading: isUploading, loadingText: "Saving" }, { children: "Save" }), void 0)] }, void 0));
};
export default ImageUploader;
